export const toNormalCase = (kebabCaseString) => {
  // Split the kebab case string into words using hyphens
  const words = kebabCaseString.split("-");

  // Capitalize the first letter of each word and join them
  const normalCaseString = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");

  return normalCaseString;
};
